module.exports = __webpack_public_path__ + "images/emoji/mag_right.38cc3686e598974c04e5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mag_right.png
// module id = VGRI
// module chunks = 2